import React, { Component } from 'react';
import { InputText } from 'primereact/inputtext';
import { InputSwitch } from 'primereact/inputswitch';
import { Dropdown } from 'primereact/dropdown';
import { connect } from 'react-redux';
import { Toast } from 'primereact/toast';
import Messages from '../../../shared/UI/Messages/Messages';

import { REDIRECT_TO_URL, HASACCESS } from '../../../shared/utility';
import { USER_SUBMENU_ID } from '../../../shared/Config';
import FooterButton from '../../../shared/UI/FooterButton/FooterButton';
import * as actions from '../../../store/actions/index';

class AddTransactionType extends Component {
    state = {
        type: 'add',
        transactionTypeId: null,
        transactionCode: '',
        transactionName: '',
        module: '',
        postingProcedure: '',
        stockEffect: true,
        sortOrder: 0,
        affectCost: true,
        allowNegativeStock: false,
        consumeBatch: false,
        createBatch: true,
        isActive: true,
        isAdjustment: false,
        isProduction: false,
        isSales: false,
        isTransfer: false,
        submenuid: null,
        transactiontypeuniqueid: null,
        CompanyId: this.props.loggedUserDetail ? this.props.loggedUserDetail.CompanyId : null,
        createdBy: this.props.loggedUserDetail ? (this.props.loggedUserDetail.userName || 'Admin') : 'Admin',
        createdDate: new Date(),
        touch: false,
        loading: false,
    }

    componentDidMount() {
        this.getAccess = HASACCESS(USER_SUBMENU_ID);
        const type = this.props.match.params.type;
        this.props.getMasterTableList('GetTransactionTypeList', this.props.loggedUserDetail.CompanyId);
        this.props.getModuleLists();

        if (type !== 'add') {
            this.timer();
        }
    }

    componentWillUnmount() {
        if (this.intervalID) {
            clearInterval(this.intervalID);
        }
    }

    timer = () => {
        this.setState({ loading: true });
        this.intervalID = setInterval(() => {
            this.fetchSingleProcess();
        }, 1000);
    }

    fetchSingleProcess = () => {
        const id = Number(this.props.match.params.id);
        const type = this.props.match.params.type;
        let storageItems = [];

        if (this.props.tableLists !== undefined) {
            storageItems = this.props.tableLists.find(item => Number(item.transactionTypeId) === id);
            clearInterval(this.intervalID);
        }

        if (storageItems) {
            this.setState({
                type,
                transactionTypeId: storageItems.transactionTypeId,
                transactionCode: storageItems.transactionCode || '',
                transactionName: storageItems.transactionName || '',
                module: storageItems.module || '',
                postingProcedure: storageItems.postingProcedure || '',
                stockEffect: storageItems.stockEffect === 'O' ? false : true,
                sortOrder: storageItems.sortOrder || 0,
                affectCost: storageItems.affectCost !== undefined ? storageItems.affectCost : true,
                allowNegativeStock: storageItems.allowNegativeStock !== undefined ? storageItems.allowNegativeStock : false,
                consumeBatch: storageItems.consumeBatch !== undefined ? storageItems.consumeBatch : false,
                createBatch: storageItems.createBatch !== undefined ? storageItems.createBatch : true,
                isActive: storageItems.isActive !== undefined ? storageItems.isActive : true,
                isAdjustment: storageItems.isAdjustment !== undefined ? storageItems.isAdjustment : false,
                isProduction: storageItems.isProduction !== undefined ? storageItems.isProduction : false,
                isSales: storageItems.isSales !== undefined ? storageItems.isSales : false,
                isTransfer: storageItems.isTransfer !== undefined ? storageItems.isTransfer : false,
                submenuid: storageItems.submenuid !== undefined ? storageItems.submenuid : null,
                transactiontypeuniqueid: storageItems.transactiontypeuniqueid !== undefined ? storageItems.transactiontypeuniqueid : null,
                CompanyId: storageItems.CompanyId || this.props.loggedUserDetail.CompanyId,
                createdBy: storageItems.createdBy || (this.props.loggedUserDetail ? this.props.loggedUserDetail.userName : 'Admin'),
                createdDate: storageItems.createdDate || new Date(),
                loading: false,
                touch: true,
            });
        }
    }

    change = (e) => {
        const { name, value } = e.target;
        this.setState({ [name]: value, touch: true });
    }

    switchChange = (name, value) => {
        this.setState({ [name]: value, touch: true });
    }

    add = () => {
        const type = this.props.match.params.type;
        const errors = [];

        if (!this.state.transactionCode || this.state.transactionCode.trim() === '') {
            errors.push('Transaction Code is required');
        }
        if (!this.state.transactionName || this.state.transactionName.trim() === '') {
            errors.push('Transaction Name is required');
        }

        if (errors.length > 0) {
            errors.forEach(error => {
                this.growl.show({ severity: 'error', summary: 'Validation Error', detail: error });
            });
            return;
        }

        const data = {
            transactionTypeId: this.state.transactionTypeId,
            transactionCode: this.state.transactionCode.trim(),
            transactionName: this.state.transactionName.trim(),
            module: this.state.module || '',
            postingProcedure: this.state.postingProcedure || '',
            stockEffect: this.state.stockEffect === true ? 'I' : 'O',
            sortOrder: Number(this.state.sortOrder) || 0,
            affectCost: !!this.state.affectCost,
            allowNegativeStock: !!this.state.allowNegativeStock,
            consumeBatch: !!this.state.consumeBatch,
            createBatch: !!this.state.createBatch,
            isActive: !!this.state.isActive,
            isAdjustment: !!this.state.isAdjustment,
            isProduction: !!this.state.isProduction,
            isSales: !!this.state.isSales,
            isTransfer: !!this.state.isTransfer,
            submenuid: this.state.submenuid !== undefined && this.state.submenuid !== null ? this.state.submenuid : null,
            transactiontypeuniqueid: this.state.transactiontypeuniqueid !== undefined && this.state.transactiontypeuniqueid !== null ? this.state.transactiontypeuniqueid : null,
            CompanyId: this.state.CompanyId,
            CreatedBy: this.state.createdBy,
            CreatedDate: this.state.createdDate,
            ...(type === 'edit' && this.state.transactionTypeId !== null && { transactionTypeId: this.state.transactionTypeId })
        };

        this.props.processDynamicData('TransactionType', type, data, 'GetTransactionTypeList');
    }

    resetData = () => {
        this.setState({
            type: 'add',
            transactionTypeId: null,
            transactionCode: '',
            transactionName: '',
            module: '',
            postingProcedure: '',
            stockEffect: true,
            sortOrder: 0,
            affectCost: true,
            allowNegativeStock: false,
            consumeBatch: false,
            createBatch: true,
            isActive: true,
            isAdjustment: false,
            isProduction: false,
            isSales: false,
            isTransfer: false,
            submenuid: null,
            transactiontypeuniqueid: null,
            CompanyId: this.props.loggedUserDetail ? this.props.loggedUserDetail.CompanyId : null,
            createdBy: this.props.loggedUserDetail ? (this.props.loggedUserDetail.userName || 'Admin') : 'Admin',
            createdDate: new Date(),
            touch: false,
        });
    }

    render() {
        if (this.props.success) {
            REDIRECT_TO_URL('/TransactionType', this.props);
        }

        let addAccess = true;
        let editAccess = true;
        if (this.getAccess !== undefined) {
            if (this.getAccess.viewAccess === false && this.props.userDetail && this.props.userDetail.userId !== this.props.match.params.id) {
                this.props.history.push('/dashboard');
            }
            addAccess = (this.getAccess.addAccess === true) ? true : false;
            editAccess = (this.getAccess.editAccess === true) ? true : false;
        }

        const accessButton = { addAccess, editAccess };
        const redirectURL = '/TransactionType';
        const isEnabled = this.state.touch === true;
        const moduleOptions = this.props.moduleLists || [];

        return (
            <div className="p-grid">
                {(this.props.loading || this.state.loading) && <div className="page-loader"></div>}
                {this.props.error !== null && <Messages type="error" message={this.props.error} />}
                {this.props.success !== null && <Messages type="success" message={this.props.success} />}
                <Toast ref={(el) => this.growl = el} />

                <div className="p-col-12">
                    <div className="card card-w-title" style={{ position: 'relative' }}>
                        <h1>{this.state.type} Transaction Type</h1>

                        <div className="p-grid mt1">
                            <div className="p-col-8 p-offset-2">
                                <div className="p-col-12">
                                    <label htmlFor="transactionCode">Transaction Code <span className="requiredColor">*</span></label>
                                </div>
                                <div className="p-col-12">
                                    <InputText className="p-col-12" id="transactionCode" name="transactionCode" placeholder="Transaction Code" value={this.state.transactionCode} onChange={this.change} />
                                </div>

                                <div className="p-col-12">
                                    <label htmlFor="transactionName">Transaction Name <span className="requiredColor">*</span></label>
                                </div>
                                <div className="p-col-12">
                                    <InputText className="p-col-12" id="transactionName" name="transactionName" placeholder="Transaction Name" value={this.state.transactionName} onChange={this.change} />
                                </div>

                                <div className="p-col-12">
                                    <label htmlFor="module">Module</label>
                                </div>
                                <div className="p-col-12">
                                    <Dropdown
                                        className="p-col-12"
                                        id="module"
                                        name="module"
                                        options={moduleOptions}
                                        value={this.state.module}
                                        onChange={(e) => this.setState({ module: e.value, touch: true })}
                                        placeholder="Select Module"
                                        filter
                                        showClear
                                    />
                                </div>

                                <div className="p-col-12">
                                    <label htmlFor="postingProcedure">Posting Procedure</label>
                                </div>
                                <div className="p-col-12">
                                    <InputText className="p-col-12" id="postingProcedure" name="postingProcedure" placeholder="postingProcedure" value={this.state.postingProcedure} onChange={this.change} />
                                </div>

                                <div className="p-col-12 mt1">
                                    <div className="p-grid">
                                        <div className="p-col-6" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                            <label htmlFor="stockEffect" style={{ marginRight: '10px' }}>Stock Effect</label>
                                            <InputSwitch checked={this.state.stockEffect} onChange={(e) => this.switchChange('stockEffect', e.value)} />
                                        </div>
                                        <div className="p-col-6">
                                            <label htmlFor="sortOrder">Sort Order</label>
                                            <InputText className="p-col-12" id="sortOrder" name="sortOrder" keyfilter="pint" placeholder="0" value={this.state.sortOrder} onChange={this.change} />
                                        </div>
                                    </div>
                                </div>

                                <div className="p-col-12 mt1">
                                    <div className="p-grid">
                                        <div className="p-col-6" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                            <label htmlFor="affectCost" style={{ marginRight: '10px' }}>Affect Cost</label>
                                            <InputSwitch checked={this.state.affectCost} onChange={(e) => this.switchChange('affectCost', e.value)} />
                                        </div>
                                        <div className="p-col-6" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                            <label htmlFor="allowNegativeStock" style={{ marginRight: '10px' }}>Allow Negative Stock</label>
                                            <InputSwitch checked={this.state.allowNegativeStock} onChange={(e) => this.switchChange('allowNegativeStock', e.value)} />
                                        </div>
                                        <div className="p-col-6" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                            <label htmlFor="consumeBatch" style={{ marginRight: '10px' }}>Consume Batch</label>
                                            <InputSwitch checked={this.state.consumeBatch} onChange={(e) => this.switchChange('consumeBatch', e.value)} />
                                        </div>
                                        <div className="p-col-6" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                            <label htmlFor="createBatch" style={{ marginRight: '10px' }}>Create Batch</label>
                                            <InputSwitch checked={this.state.createBatch} onChange={(e) => this.switchChange('createBatch', e.value)} />
                                        </div>
                                        <div className="p-col-6" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                            <label htmlFor="isActive" style={{ marginRight: '10px' }}>Is Active</label>
                                            <InputSwitch checked={this.state.isActive} onChange={(e) => this.switchChange('isActive', e.value)} />
                                        </div>
                                        <div className="p-col-6" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                            <label htmlFor="isAdjustment" style={{ marginRight: '10px' }}>Is Adjustment</label>
                                            <InputSwitch checked={this.state.isAdjustment} onChange={(e) => this.switchChange('isAdjustment', e.value)} />
                                        </div>
                                        <div className="p-col-6" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                            <label htmlFor="isProduction" style={{ marginRight: '10px' }}>Is Production</label>
                                            <InputSwitch checked={this.state.isProduction} onChange={(e) => this.switchChange('isProduction', e.value)} />
                                        </div>
                                        <div className="p-col-6" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                            <label htmlFor="isSales" style={{ marginRight: '10px' }}>Is Sales</label>
                                            <InputSwitch checked={this.state.isSales} onChange={(e) => this.switchChange('isSales', e.value)} />
                                        </div>
                                        <div className="p-col-6" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                            <label htmlFor="isTransfer" style={{ marginRight: '10px' }}>Is Transfer</label>
                                            <InputSwitch checked={this.state.isTransfer} onChange={(e) => this.switchChange('isTransfer', e.value)} />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="p-col-12 p-lg-12">
                                <FooterButton
                                    access={accessButton}
                                    disabled={!isEnabled}
                                    type={this.state.type}
                                    save={this.add}
                                    reset={this.resetData}
                                    to={redirectURL}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        loggedUserDetail: state.auth.userObject,
        userDetail: state.auth.userDetail,
        loading: state.master.loading,
        error: state.master.error,
        success: state.master.success,
        tableLists: state.master.tableLists,
        moduleLists: state.master.moduleLists || []
    };
};

const mapDispatchToProps = dispatch => {
    return {
        getMasterTableList: (table, companyId) => dispatch(actions.getMasterTableList(table, companyId)),
        getModuleLists: () => dispatch(actions.getModuleLists()),
        processDynamicData: (model, type, data, func) => dispatch(actions.processDynamicData(model, type, data, func)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(AddTransactionType);